import { useEffect, useState } from 'react';

/*
Instructions

1. Set total number first when you call the function that you want to paginate (for this example functionWhenYouCallBe())

2. Create two functions queryMore and queryLess that will be used for pagination
* function queryMore() {
		const newPage = currentPage + 1
		setCurrentPage(newPage)
		functionWhenYouCallBe(calculateOffset(newPage))
}
* function queryLess() {
		const newPage = currentPage - 1 // or newPage = 0 if you want to start from the beggining
		setCurrentPage(newPage)
		functionWhenYouCallBe(calculateOffset(newPage))
 }

 3. After that you just need to look does this hook returns hasNext and hasPrev as true or false and display the pagination button accordingly
*/

export default function usePagination() {
  // limit = items per call (9 is default)
  const [limit, setLimit] = useState(9);
  // are we able to paginate more forward
  const [hasNext, setNext] = useState(true);
  // are we ablle to paginate more backwards (only avaliable when we reach the end of the forward pagination)
  const [hasPrev, setPrev] = useState(false);
  // which page is currently on
  const [currentPage, setCurrentPage] = useState(1);
  // total count of items that we are geeting from BE
  const [totalCount, setTotalCount] = useState(0);

  // page count = total / limit
  // transforming totalCount to pages by deviding the total count with the limit
  const pageCount = (totalCount: number) => Math.ceil(totalCount / limit);

  // offset - will take current page and the limit to calculate which records are next for pagination (9->18->27->...)
  const calculateOffset = (page: number) => (page - 1) * limit;

  useEffect(() => {
    if (pageCount(totalCount) <= 1) {
      // because 1 is defeault page number
      // if total pages is smaller then 1 then we don't have paginatio at all so hasNext and hasPrev are false
      setNext(false);
      setPrev(false);
    } else if (currentPage === pageCount(totalCount) && pageCount(totalCount) > 0) {
      // we already reach the end of pagination and from now on we can only move back
      setNext(false);
      setPrev(true);
    } else if (pageCount(totalCount) > currentPage) {
      // we have still more pages to pagination (setPrev is only avaliable when we reach the end of our pagination)
      setNext(true);
      setPrev(false);
    }
  }, [currentPage, totalCount]);

  return {
    hasNext,
    hasPrev,
    setCurrentPage,
    setTotalCount,
    currentPage,
    setLimit,
    limit,
    calculateOffset,
  };
}
